// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ReGenerateApiKeyRequestModel from '../../model/re-generate-api-key-request-model';
import ReGenerateApiKeyRequestDTO from '../dto/re-generate-api-key-request-dto';
import dtoSchema from '../schemas/re-generate-api-key-request-schema';

export default abstract class ReGenerateApiKeyRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ReGenerateApiKeyRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<ReGenerateApiKeyRequestDTO>): ReGenerateApiKeyRequestModel;
  static toModel(dto: DeepPartial<ReGenerateApiKeyRequestDTO> | undefined | null): ReGenerateApiKeyRequestModel | undefined;
  static toModel(dto: DeepPartial<ReGenerateApiKeyRequestDTO> | undefined | null): ReGenerateApiKeyRequestModel | undefined {
    return dto ? new ReGenerateApiKeyRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ReGenerateApiKeyRequestModel> | ReGenerateApiKeyRequestModel): ReGenerateApiKeyRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as ReGenerateApiKeyRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ReGenerateApiKeyRequestModel, can not map to ReGenerateApiKeyRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
